module.exports = __webpack_public_path__ + "img/diamonds-2.ebe3064.webp";